import { render, staticRenderFns } from "./mainForm.vue?vue&type=template&id=06b1e866&scoped=true&"
import script from "./mainForm.vue?vue&type=script&lang=js&"
export * from "./mainForm.vue?vue&type=script&lang=js&"
import style0 from "./mainForm.vue?vue&type=style&index=0&id=06b1e866&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b1e866",
  null
  
)

export default component.exports